var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{staticClass:"cr-checkbox",attrs:{"value":_vm.value},on:{"change":function (val) { return _vm.$emit('change', val); },"input":function (val) { return _vm.$emit('input', val); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }